import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './image-card.module.scss'
import { Image } from '@components/image'
import type { MediumImageFragment } from '@graphql/fragments/MediumImageFragment.graphql'

export const ImageCard: FunctionComponent<ImageCardProps> = ({
    alt,
    source,
    source2x,
    source3x,
    contentType,
}) => {
    return (
        <div className={styles.card}>
            <Image
                className={classNames(styles.image)}
                source={source}
                source2x={source2x}
                source3x={source3x}
                contentType={contentType}
                alt={alt}
                lazy
            />
        </div>
    )
}

export default ImageCard

export interface ImageCardProps
    extends Omit<MediumImageFragment, 'sys' | 'type'> {
    index: number
}
